import mcli from './index';
const isSystemUser = (userId, name) => {
    const normalizedName = (name || '').trim().toLowerCase();
    const normalizedUserId = (userId || '').toLowerCase();
    return normalizedName === 'matrixadmin' || normalizedUserId.includes('matrixadmin');
};
export const getInviteSender = (room) => {
    const myUserId = mcli.getUserId();
    if (!myUserId)
        return undefined;
    const me = room.getMember(myUserId);
    const sender = me?.events?.member?.getSender();
    return sender || room.getDMInviter() || undefined;
};
export const isAdminInvite = (room) => {
    return isSystemUser(getInviteSender(room));
};
